import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!query.state.data) {
        toast.error((error as any).error.detail);
      }
    },
  }),
});

export default queryClient;
